import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import React, { useMemo } from 'react';

export const VARIANTS = {
  BLUE: 'blue',
  WHITE: 'white',
};

const BrandAvatar = ({ size, isBlock, className, variant, ...props }) => {
  const cn = useClassNames(
    () => [
      'relative',
      !isBlock && 'inline-block',
      isBlock && 'block',
      size === '6' && 'w-6',
      size === '6' && 'h-6',
      size === '8' && 'w-8',
      size === '8' && 'h-8',
      size === '10' && 'w-10',
      size === '10' && 'h-10',
      size === '12' && 'w-12',
      size === '12' && 'h-12',
      size === '16' && 'w-16',
      size === '16' && 'h-16',
      size === '20' && 'w-20',
      size === '20' && 'h-20',
      size === '24' && 'w-24',
      size === '24' && 'h-24',
      size === '32' && 'w-32',
      size === '32' && 'h-32',
      'select-none',
      className,
    ],
    [className],
  );

  const colors = useMemo(() => {
    if (variant === VARIANTS.WHITE) {
      return ['#fff', '#fff'];
    }

    return ['#0052a1', '#469df1'];
  }, [variant]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <svg data-component="BrandAvatar" viewBox="0 0 90.85 95.66" className={cn} {...props}>
      <path
        d="M37.2,0A37.21,37.21,0,0,0,0,37.2V95.66L21.26,74.41H37.2A37.21,37.21,0,0,0,74.41,37.2V0Z"
        style={{ fill: colors[0] }}
      />
      <path
        d="M64.36,21.54A26.49,26.49,0,0,1,90.85,48V89.66L75.72,74.52H64.36A26.49,26.49,0,0,1,37.87,48V21.54Z"
        style={{ fill: colors[1], opacity: 0.7 }}
      />
    </svg>
  );
};

BrandAvatar.propTypes = {
  size: PropTypes.oneOf(['6', '8', '10', '12', '16', '20', '24', '32']),
  isBlock: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
};

BrandAvatar.defaultProps = {
  isBlock: false,
  size: '12',
  variant: VARIANTS.BLUE,
  className: null,
  children: null,
};

export default BrandAvatar;
